<template>
    <div>


        <FormGroup label="Printer">
            <b-form-select ref="printer" v-model="form.printer" :options="printers"></b-form-select>
        </FormGroup>

        <FormGroup label="QZ Printer">
            <b-form-select ref="qzPrinter" v-model="form.qzPrinter" :options="qzPrinters"></b-form-select>
        </FormGroup>

        <FormGroup label="Stregkode">
            <b-form-input ref="barcode" type="text" v-model="form.barcode" @change="change" autocomplete="off" :readonly="form.order != null"></b-form-input>
        </FormGroup>

        <div v-if="form.order">

            <h3>Ordre: {{form.order.number}}</h3>
            <p>
                Levering:
                <br />
                {{form.order.shippingMethod}}
            </p>

            <b-alert variant="warning" :show="form.order.reprintOnly === true">
                Ordren er allerede afsluttet - der kan kun genudskrives labels.
            </b-alert>

            <FormGroup label="Handling">
                <b-form-input ref="action" type="text" v-model="form.action" @change="actionChange" autocomplete="off" :readonly="!actionEnabled"></b-form-input>
            </FormGroup>

            <b-button v-if="form.order.reprintOnly === true" size="sm" variant="outline-secondary" @click="reset">
                Scan ny ordre
            </b-button>
        </div>

        <b-alert variant="danger" :show="form.error != null">{{form.error}}</b-alert>
        <b-alert variant="success" :show="form.message != null">{{form.message}}</b-alert>

    </div>
</template>

<script>
    import qz from "qz-tray";
    import TextEditor from "../../_ui/editors/text";

    export default {
        data: () => ({
            form: {
                printer: null,
                qzPrinter: null,
                barcode: null,
                order: null,
                action: null,
                error: null,
                message: null
            },
            actionEnabled: false,
            printers: [],
            qzPrinters: [],
        }),
        components: { TextEditor },
        computed: {},
        watch: {
            "form.printer"(val) {
                if (window.localStorage) {
                    localStorage.setItem("printer", val)
                }
            },
            "form.qzPrinter"(val) {
                if (window.localStorage) {
                    localStorage.setItem("qzPrinter", val)
                }
            }
        },
        props: [],
        methods: {
            change() {
                this.$http.get("/api/module/smartweborders/order", {
                    params: {
                        id: this.form.barcode
                    }
                }).then(x => {
                    if (x.data.number) {
                        this.form.order = x.data;
                        this.form.error = null;
                        setTimeout(() => {
                            this.$refs.action.focus();
                            this.actionEnabled = true;
                        }, 200);
                    } else {
                        this.form.barcode = null;
                        this.form.order = null;
                        this.form.action = null;
                        this.form.message = null;

                        this.form.error = x.data;
                    }
                });
            },
            // A reprint only order is never completed by a scan, so it needs a
            // way back to scanning the next order.
            reset() {
                this.actionEnabled = false;
                this.form.barcode = null;
                this.form.order = null;
                this.form.action = null;
                this.form.message = null;
                this.form.error = null;

                setTimeout(() => {
                    this.$refs.barcode.focus();
                }, 200);
            },
            actionChange() {
                this.actionEnabled = false;
                this.$http.post("/api/module/smartweborders/scan/action", null, {
                    params: {
                        id: this.form.barcode,
                        action: this.form.action,
                        printer: this.form.printer
                    }
                }).then(async x => {

                    // The backend returns either a plain action string (existing
                    // flows) or an object carrying ZPL labels (Økoskabet).
                    var data = x.data;
                    var action = typeof data === "string" ? data : data.action;

                    if (data && typeof data === "object" && data.zpl) {
                        try {
                            await this.printZpl(data.zpl);
                            await this.logPrintResult(true, null);
                        } catch (err) {
                            var message = err && err.message ? err.message : String(err);

                            // The print happens client side, so the failure is
                            // only known here - log it on the order as well.
                            await this.logPrintResult(false, message);

                            this.actionEnabled = true;
                            this.form.action = null;
                            this.form.error = "Kunne ikke printe labels: " + message;
                            setTimeout(() => {
                                this.$refs.action.focus();
                            }, 200);
                            return;
                        }
                    }

                    if (action && (action.startsWith("reprint-shipping-label") || action.startsWith("reprint+shipping+label"))) {
                        this.actionEnabled = true;
                        this.form.action = null;
                        this.form.error = null;
                        this.form.message = "Labels genudskrevet!";

                        setTimeout(() => {
                            this.$refs.action.focus();
                        }, 200);
                    } else if (action && (action.startsWith("print-shipping-label") || action.startsWith("print+shipping+label"))) {
                        this.actionEnabled = true;
                        this.form.action = null;
                        this.form.message = "Label bestilt!";

                        setTimeout(() => {
                            this.$refs.action.focus();
                        }, 200);
                    } else if (action == "complete-order" || action == "complete+order") {
                        this.form.barcode = null;
                        this.form.order = null;
                        this.form.action = null;
                        this.form.message = "Ordre afsluttet! Scan næste ordre.";

                        setTimeout(() => {
                            this.$refs.barcode.focus();
                        }, 200);
                    } else {
                        this.form.barcode = null;
                        this.form.order = null;
                        this.form.action = null;
                        this.form.message = null;

                        this.form.error = action;
                    }
                })
                    .catch(error => {
                        this.actionEnabled = true;
                        this.form.action = null;
                        setTimeout(() => {
                            this.$refs.action.focus();
                        }, 200);

                        this.form.error = "Der opstod en ukendt fejl.";
                    });
            },
            // Reports the client side print outcome back to the order. A
            // failure here must never break the scanning flow, so it is
            // swallowed.
            async logPrintResult(success, error) {
                try {
                    await this.$http.post("/api/module/smartweborders/scan/print-result", {
                        success: success,
                        error: error
                    }, {
                        params: {
                            id: this.form.barcode
                        }
                    });
                } catch (e) {
                }
            },
            async printZpl(zpl) {
                if (!this.form.qzPrinter) {
                    throw new Error("Ingen QZ printer valgt.");
                }

                await this.connectQz();

                // zpl is one or more base64 encoded ZPL files. QZ decodes the
                // base64 itself (flavor), so the UTF-8 label content survives
                // intact all the way to the printer.
                var labels = (Array.isArray(zpl) ? zpl : [zpl]).map(x => ({
                    type: "raw",
                    format: "command",
                    flavor: "base64",
                    data: x
                }));

                var config = qz.configs.create(this.form.qzPrinter);
                await qz.print(config, labels);
            },
            cancel() {
                this.$emit("close");
            },
            shown() {
                this.$refs.barcode.focus()
            },
            getPrinters() {
                this.$http.get("/api/module/smartweborders/scan/printers").then(x => {
                    this.printers = x.data;

                    if (window.localStorage) {
                        var printer = localStorage.getItem("printer")
                        if (printer && x.data.find(x => x.value == printer)) {
                            this.form.printer = printer;
                        } else {
                            this.form.printer = x.data[0].value;
                        }
                    }
                });
            },

            getQzPrinters() {
                qz.printers.find().then(found => {
                    this.qzPrinters = found;

                    if (window.localStorage) {
                        var printer = localStorage.getItem("qzPrinter")
                        if (printer && found.find(x => x == printer)) {
                            this.form.qzPrinter = printer;
                        } else {
                            this.form.qzPrinter = found[0];
                        }
                    }
                });
            },

            async connectQz() {
                this.configureQzSecurity();

                if (!qz.websocket.isActive()) {
                    await qz.websocket.connect({
                        host: "localhost.qz.io",
                        retries: 3,
                        delay: 1
                    });

                    this.getQzPrinters();
                } else {
                    
                    this.getQzPrinters();
                }

            },
            configureQzSecurity() {
                qz.security.setCertificatePromise((resolve, reject) => {
                    fetch("/api/qz/certificate", {
                        method: "GET",
                        cache: "no-store",
                        credentials: "include"
                    })
                        .then(async response => {
                            const certificate = await response.text();

                            if (!response.ok) {
                                throw new Error(certificate);
                            }

                            resolve(certificate);
                        })
                        .catch(reject);
                });

                qz.security.setSignatureAlgorithm("SHA512");

                qz.security.setSignaturePromise(toSign => {
                    return (resolve, reject) => {
                        fetch("/api/qz/sign", {
                            method: "POST",
                            credentials: "include",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                request: toSign
                            })
                        })
                            .then(async response => {
                                const signature = await response.text();

                                if (!response.ok) {
                                    throw new Error(signature);
                                }

                                resolve(signature);
                            })
                            .catch(reject);
                    };
                });
            }
        },
        created() {
            this.getPrinters();

            this.connectQz();
        },
        mounted() {
        },
    };
</script>